import type { RichTextBlockProps } from '../types';
import { theme, sectionColors } from '../theme';

/**
 * Pure rich-text. Renders an optional heading + plain-text paragraphs, all
 * React-escaped. Deliberately does NOT use dangerouslySetInnerHTML — only the
 * raw_html shim does (Claude-web guidance).
 */
export function RichTextBlock(props: RichTextBlockProps) {
  const { heading, paragraphs } = props;
  // Light by default (no band): transparent background, brand text color.
  const colors = sectionColors(props, { bg: 'transparent', text: theme.text });
  return (
    <div className="px-6 py-12" style={{ ...colors, fontFamily: theme.bodyFont }}>
      <div className="mx-auto max-w-3xl">
        {heading ? <h2 className="mb-4 text-2xl font-semibold" style={{ fontFamily: theme.headingFont }}>{heading}</h2> : null}
        {paragraphs.map((p, i) => (
          <p key={i} className="mb-4 text-base leading-relaxed">{p}</p>
        ))}
      </div>
    </div>
  );
}
